import moment from 'moment'
import { OrderBy } from './contexts/approvalContext/types'

export const COLUMNS = [
  { label: 'Submission Name', type: 'text', width: '23%', lookup: OrderBy.SUBMISSION_NAME },
  { label: 'Created By', type: 'text', lookup: OrderBy.CREATED_BY },
  { label: 'Rows', type: 'number', width: '10%', blockSort: true },
  { label: 'Submitted Date', type: 'date', lookup: OrderBy.CREATED_AT },
  { label: 'Status', width: '25%', lookup: 'status', blockSort: true },
  { label: 'Actions', lookup: 'actions', blockSort: true },
]

export const getColumns = (DATASETS_PAGE_ENABLED: boolean) => [
  {
    label: DATASETS_PAGE_ENABLED ? 'Dataset' : 'Template',
    type: 'text',
    width: '20%',
    lookup: OrderBy.TEMPLATE_NAME,
  },
  { label: 'Submission Name', type: 'text', width: '20%', lookup: OrderBy.SUBMISSION_NAME },
  { label: 'Created By', type: 'text', lookup: OrderBy.CREATED_BY },
  { label: 'Rows', type: 'number', width: '10%', blockSort: true },
  { label: 'Submitted Date', type: 'date', lookup: OrderBy.CREATED_AT },
  { label: 'Status', width: '17%', lookup: 'status', blockSort: true },
  { label: 'Actions', lookup: 'actions', blockSort: true },
]

export const TODAY = moment().endOf('day')

export const LIMIT_PER_PAGE = 100

export const ALL_USERS = {
  value: 0,
  label: 'All Users',
}
